var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormEvent", {
                attrs: {
                  category: _vm.eventCategory,
                  eventSchedules: _vm.getEventSchedules,
                  isEventSchedulesLoading: _vm.isEventSchedulesLoading,
                  isEventTicketGroupsLoading: _vm.isEventTicketGroupsLoading,
                  data: _vm.event,
                  categories: _vm.eventCategories,
                  seating: _vm.getEventSeating,
                  cities: _vm.cities,
                  places: _vm.places,
                  routes: _vm.routes,
                  ticketGroups: _vm.getEventTicketGroups,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isEventSeatingLoading: _vm.isEventSeatingLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                  "reservations-count": _vm.reservationsCount,
                },
                on: {
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-events" })
                  },
                  "delete-event": _vm.deleteEvent,
                  "delete-event-schedule": _vm.deleteEventSchedule,
                  submit: _vm.eventSubmitHandle,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "new-event-schedule": _vm.newEventScheduleHandler,
                  "delete-seat-row": _vm.deleteSeatRow,
                  "delete-seat-zone": _vm.deleteSeatZone,
                  "delete-seat": _vm.deleteSeat,
                  seating: _vm.eventSeatingSubmitHandler,
                  "delete-ticket-group": _vm.deleteTicketGroup,
                  "generate-event-schedule": _vm.generateEventSchedule,
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmEventRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }